// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const getFlexProperty = (props) => {
  const { fromConfirmation, isBagPage, isAddedToBag } = props;

  if (fromConfirmation) {
    return `0 0 143px`;
  }
  if (isBagPage || isAddedToBag) {
    return `0 0 155px`;
  }
  return `
  0 0 163px
  `;
};

const getFlexValueOnMinLength = (props) => {
  const { isBagPage, isAddedToBag } = props;

  if (isAddedToBag) {
    return `0 0 146px`;
  }
  if (isBagPage) {
    return `1 0 166px`;
  }
  return `
  1 0 218px
  `;
};

export default css`
  .recommendations-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        !(props.isAddedToBag || props.isBagPage) &&
        `margin: ${props.theme.spacing.ELEM_SPACING.LRG} 0 ${props.theme.spacing.ELEM_SPACING.LRG}};`}
      width: 100%;
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isBagPage &&
        props.isBIACombinedCarouselEnabled &&
        ` margin-top: ${props.theme.spacing.ELEM_SPACING.XL_1};`}
    }
  }

  .accordion-header-new,
  .recommendations-header-new {
    color: ${(props) => props.theme.colors.BLACK};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy5}px;
    }
  }

  .accordion-header-new {
    display: flex;
    align-items: center;
    width: 100%;

    ${(props) =>
      props.isPdpPlaProducts
        ? `
    text-align: center;
    :before {
      content: '';
      border-top: 1px solid ${props.theme.colors.BLACK};
      margin-right: ${props.theme.spacing.ELEM_SPACING.XS_1};
      flex: 1 0 ${props.theme.spacing.APP_LAYOUT_SPACING.XS};
    }

    :after {
      content: '';
      border-top: 1px solid ${props.theme.colors.BLACK};
      margin-left: ${props.theme.spacing.ELEM_SPACING.XS_1};
      flex: 1 0 ${props.theme.spacing.APP_LAYOUT_SPACING.XS};
    }

    @media ${props.theme.mediaQuery.large} {
      :before {
        margin-right: ${props.theme.spacing.APP_LAYOUT_SPACING.XS};
      }

      :after {
        margin-left: ${props.theme.spacing.APP_LAYOUT_SPACING.XS};
      }
    }`
        : ''}
  }

  .recommendation-product-section {
    ${(props) =>
      props.isAddedToBag
        ? `
    position: relative;
    width: 110%;
    @media ${props.theme.mediaQuery.medium} {
    width: 90%;
    margin-left: 24px;
        }`
        : `overflow: hidden;
    position: relative;
    width: 100%;`}

    .slick-arrow {
      width: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
      height: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
      border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
      background-color: ${(props) => props.theme.colors.GHOST_OVERLAY};
    }

    .slick-arrow.slick-prev {
      left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }

    .slick-arrow.slick-next {
      right: 26px;
    }

    &:hover .slick-arrow,
    &:focus-within .slick-arrow {
      display: block !important;
    }

    .slick-arrow.slick-disabled {
      display: none !important;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 438px;
    }
  }

  ${(props) =>
    props.isAddedToBag &&
    `.recommendation-product-section .slick-next {
        margin-right : 0px;
        top: 50%;
        width: 40px;
        height: 40px;
        padding: 0px;
      }
      .recommendation-product-section .slick-arrow.slick-next{
        right: 0px;
      }
      .recommendation-product-section .slick-next::after{
        border-width: 0 2px 2px 0;
        padding: 5px;
        margin-right: 5px;
      }
      .recommendation-product-section .slick-prev::after{
        border-width: 0 2px 2px 0;
        padding: 5px;
        margin-left: 5px;
      }
      .recommendation-product-section .slick-prev {
        margin-left : 0px;
        top: 50%;
        width: 40px;
        height: 40px;
        padding: 0px;
        transform: translate(0px, -50%);
      }
      .recommendation-product-section .slick-arrow.slick-prev {
        left: -24px;
      }
      .rating-star-overlay{
        height: 12px;
      }
      .custom-ranking-container .reviews-count{
        margin-left: 10px;
        @media ${props.theme.mediaQuery.smallOnly} {
          margin-left: 16px;

        }
      }
      .custom-ranking-container div {
        height: 14px;
      }
      .recommendations-wrapper{
        @media ${props.theme.mediaQuery.smallOnly} {
          margin-left: 0px;
        }
      }
      `}

  .no-carousel-container-desktop {
    display: flex;
    width: 100%;
    overflow: hidden;

    @media ${(props) => props.theme.mediaQuery.large} {
      .recommendation-tile {
        flex: ${(props) => getFlexValueOnMinLength(props)};
        max-width: ${(props) => (props.isBagPage ? '280px' : '264px')};
      }
    }
  }

  .hide-recommendations ~ .recommendation-product-section {
    display: none;

    @media ${(props) => props.theme.mediaQuery.large} {
      display: block;
    }
  }

  .scroll-container-mobile-tablet {
    display: flex;
    overflow-x: scroll;
    column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XS};

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }

    .recommendation-tile {
      flex: ${(props) => getFlexProperty(props)};
      min-height: 299px;

      @media (min-width: 360px) and (max-width: 380px) {
        flex: 0 0 153px;
        min-height: 287px;
      }

      @media (min-width: 500px) and (max-width: 550px),
        (min-width: 680px) and (max-width: 730px),
        (min-width: 860px) and (max-width: 900px),
        (min-width: 1024px) and (max-width: 1064px) {
        flex: 0 0 175px;
        min-height: 314px;
      }
    }
  }
`;
